module.exports = __webpack_public_path__ + "media/images/sales/early/btn-cta-2-95d3ca6ea13b16dfa40bc668eae4d4a4.svg";